$(document).ready(function () {
  // General Message
  //--------------------------------------
  $('.generalmessage').prependTo('header');

  // Blue line if banner is inactive
  if (!$('#pnl_banner').text().length > 0) {
    $('.header .headerInnerContent').prepend('<div class="missing-bar"></div>');
  }

  // Search Bar Script
  //--------------------------------------
  $('.searchBoxInput input').attr('placeholder', 'Search');
  $('.searchBoxInput input').val('');
  $('#mobileSearchInput').attr('placeholder', '');
  $('#mobileSearchInput').val('');


  // Footer signup
  //--------------------------------------
  $('.footer .emailSignup .emailSignupText').text('Sign up for our newsletter');
  $('.footer .emailSignup input').attr('placeholder', 'Enter Email...');
  $('.footer .emailSignup input').val('');
  $('.footer .emailSignup .emailInputSubmit a').text('Submit');
  $('.footer .emailSignup .emailInputField, .footer .emailSignup .emailInputSubmit').wrapAll('<div class="sign-form"></div>')

  // Countdown custom script
  //--------------------------------------
  $(window).load(function () {
    $('.countdown-container').appendTo('header');
    setTimeout(() => {
      const $siteInfoBannerWidget = $('#siteInfoBannerWidget');
      const $eventDates = $siteInfoBannerWidget.find('#eventDates');
      const $eventName = $siteInfoBannerWidget.find('#eventName');
      const $countdownDays = $siteInfoBannerWidget.find('.countdownDays');
      const $countdownContainer = $('.countdown-container');

      // Optional to add icon after event dates
      $eventDates.after('<span class="count-icon"></span>'); 

      const activeBanner = $countdownDays.text();

      if (activeBanner) {
        if (activeBanner === "Thanks for a great event!") {
          $('body').addClass('thanksMessage');
        } else {
          const daysCount = $countdownDays.text();
          const eventNameText = $eventName.clone().children().remove().end().text();
          const newEventName = `Only ${daysCount} until ${eventNameText}`;
          $eventName.html(newEventName);
        }
      }

      if (activeBanner || $eventDates.text().trim()) {
        $countdownContainer.css('opacity', '1');
      } else {
        $countdownContainer.remove();
      }

    }, 1000);
  })
});





